import api from '@pray/shared/utils/api';
import type { PaginatedListResponse } from '@pray/shared/utils/api/types/response';

import type { ContentViewResponse, PaginationParams } from './types';

export async function getMemberContentViews(memberId: string, params: PaginationParams = {}) {
  const url = `/web/studio/users/${memberId}/content-views`;

  const queryParams = {
    limit: params.limit ?? 50,
    offset: params.offset ?? 0,
  };

  const response = await api.executeGetRequest<PaginatedListResponse<ContentViewResponse>>(url, queryParams);

  return response.data;
}
